import {ApolloClient} from "@apollo/client/core";
import {Attribute, PreferenceMeta} from "./index";

export class UserPreferenceStubClient {

    getUserPreferences = async (
        client: ApolloClient<any>, app: string | null,
        alias: string | null, preferenceNameList: string[] | null,
        nextToken: Attribute[] | null = null, noOfPreferences: number = 1): Promise<any> => {
        return Promise.resolve([]);
    };

    saveUserPreferences = async (client: ApolloClient<any>, preferenceListInput: PreferenceMeta[], applicationName: string = "") => {
        return Promise.resolve();
    };
}